import { render } from "./TradeMainTop.vue?vue&type=template&id=6ed9d5bb"
import script from "./TradeMainTop.vue?vue&type=script&lang=js"
export * from "./TradeMainTop.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__